module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "id": "paymentAlert",
      "role": "warning"
    }
  }, [_c('strong', [_vm._v("Payment was not approved: ")]), _vm._v(_vm._s(_vm.paymentResponse.ResultMessage) + "\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Transaction ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.paymentResponse.TransactionId))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Transaction Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.paymentResponse.TransactionDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.paymentResponse.Amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "name": "button2",
      "type": "submit"
    },
    on: {
      "click": _vm.goPayment
    }
  }, [_vm._v("Return to Payment")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('h4', [_vm._v("paymentResponse: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.$route.query))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e34de7e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FileSearchPaymentFail.vue
// module id = 999
// module chunks = 1